// Dummy data for preview mode
export const dummyData = {
    name: "Alex Johnson",
    email: "alex.johnson@example.com",
    phone: "555-123-4567",
    basic_details: {
        gender: "Male",
        dob: "1990-05-15",
        marital_status: "Single",
        address: "123 Main Street",
        address1: "Apt 4B",
        city: {
            name: "San Francisco",
        },
        state: {
            name: "California",
        },
        country: {
            name: "United States",
        },
        pincode: 94105,
        profile_summery:
            "Dedicated and innovative software engineer with 7+ years of experience in full-stack development. Passionate about creating efficient, scalable solutions and mentoring junior developers. Proven track record of delivering high-quality applications that drive business growth and enhance user experience.",
    },
    employment: [
        {
            current_company: "Tech Innovations Inc.",
            employement_type: "Full Time",
            experience_year: 4,
            experience_month: 3,
            job_title: {
                title: "Senior Software Engineer",
            },
            start_year: 2019,
            start_month: 3,
            end_year: null,
            end_month: null,
            current_salary_amount: 120000,
            job_profile:
                "Lead a team of 6 developers in building and maintaining enterprise SaaS applications. Architect and implement scalable backend services using Node.js and Python. Collaborate with product managers to define feature requirements and timelines.",
            department: {
                title: "Engineering",
            },
        },
        {
            current_company: "Digital Solutions LLC",
            employement_type: "Full Time",
            experience_year: 3,
            experience_month: 2,
            job_title: {
                title: "Full Stack Developer",
            },
            start_year: 2016,
            start_month: 1,
            end_year: 2019,
            end_month: 2,
            current_salary_amount: 85000,
            job_profile:
                "Developed and maintained web applications using React, Angular, and Node.js. Implemented RESTful APIs and integrated third-party services. Improved application performance by 40% through code optimization and database query refinement.",
            department: {
                title: "Product Development",
            },
        },
    ],
    projects: [
        {
            project_tag: "Cloud Migration Platform",
            project_status: "Completed",
            work_from_year: 2020,
            work_from_month: 6,
            work_till_year: 2021,
            work_till_month: 8,
            project_description:
                "Led the development of a cloud migration platform that helped enterprise clients transition from on-premise to cloud infrastructure, resulting in 60% cost savings and 35% improved system performance for clients.",
            employment_type: "Full Time",
            team_size: 8,
            role: "Technical Lead",
            role_description: "Managed technical aspects of the project and supervised a team of developers.",
            skill_used: "AWS, Docker, Kubernetes, Node.js, React",
        },
        {
            project_tag: "AI-Powered Analytics Dashboard",
            project_status: "Ongoing",
            work_from_year: 2021,
            work_from_month: 9,
            project_description:
                "Developing an analytics dashboard with AI capabilities to provide predictive insights for business metrics. The system processes over 1TB of data daily and serves insights to 500+ concurrent users.",
            employment_type: "Full Time",
            team_size: 5,
            role: "Lead Developer",
            role_description: "Responsible for architecture, implementation, and team coordination.",
            skill_used: "Python, TensorFlow, React, D3.js, MongoDB",
        },
    ],
    education: [
        {
            education: {
                title: "Graduate (PG)",
            },
            education_course: {
                title: "Master of Science (M.S.)",
            },
            education_course_specialty: {
                title: "Computer Science",
            },
            insitute_university: "Stanford University",
            course_type: "Full Time",
            course_duration_start_year: 2014,
            course_duration_end_year: 2016,
            grading_system: "GPA",
            marks: "3.9",
        },
        {
            education: {
                title: "Undergraduate (UG)",
            },
            education_course: {
                title: "Bachelor of Science (B.S.)",
            },
            education_course_specialty: {
                title: "Software Engineering",
            },
            insitute_university: "University of Washington",
            course_type: "Full Time",
            course_duration_start_year: 2010,
            course_duration_end_year: 2014,
            grading_system: "GPA",
            marks: "3.8",
        },
    ],
    certifications: [
        {
            certification_name: "AWS Certified Solutions Architect - Professional",
            certification_number: "AWS-PSA-12345",
            certification_date: "2022-03-15",
            certification_validity: "2025-03-15",
        },
        {
            certification_name: "Google Cloud Professional Data Engineer",
            certification_number: "GCP-PDE-67890",
            certification_date: "2021-08-10",
            certification_validity: "2024-08-10",
        },
        {
            certification_name: "Certified Kubernetes Administrator (CKA)",
            certification_number: "CKA-123456",
            certification_date: "2022-01-20",
            certification_validity: "2025-01-20",
        },
    ],
    it_skills: [
        {
            skill: {
                title: "JavaScript",
            },
            versions: "ES6+",
            experience_year: 7,
            experience_month: 0,
        },
        {
            skill: {
                title: "React",
            },
            versions: "18",
            experience_year: 5,
            experience_month: 6,
        },
        {
            skill: {
                title: "Node.js",
            },
            versions: "16",
            experience_year: 6,
            experience_month: 2,
        },
        {
            skill: {
                title: "Python",
            },
            versions: "3.9",
            experience_year: 4,
            experience_month: 8,
        },
        {
            skill: {
                title: "AWS",
            },
            versions: "",
            experience_year: 5,
            experience_month: 3,
        },
    ],
    candidate_languages: [
        {
            language: "English",
            can_read: 1,
            can_write: 1,
            can_speak: 1,
        },
        {
            language: "Spanish",
            can_read: 1,
            can_write: 1,
            can_speak: 1,
        },
        {
            language: "French",
            can_read: 1,
            can_write: 0,
            can_speak: 0,
        },
    ],
}
